import { render, staticRenderFns } from "./GiftCode.vue?vue&type=template&id=5243d78b&scoped=true"
import script from "./GiftCode.vue?vue&type=script&lang=js"
export * from "./GiftCode.vue?vue&type=script&lang=js"
import style0 from "./GiftCode.vue?vue&type=style&index=0&id=5243d78b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5243d78b",
  null
  
)

export default component.exports